import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {useMemo} from 'react';
import {
  MiniAdpDialogOpenedStateKey,
  useMiniAdpDialogOpenedState,
} from '../../../MiniADPDialog/useMiniAdpDialogOpenedState';
import {SizeSelectionOpenedStateKey} from '../../../SizeSelectionFlyout/hooks/useSizeSelectionOpenedState';

export const useSizeSelectionOpenedStateManager = ({
  isMiniADP,
}: {
  isMiniADP: boolean;
}) => {
  const {
    open: openSizeSelection,
    isOpen: isSizeSelectionOpen,
    cancel: closeSizeSelection,
  } = useOpenedStateManager(
    SizeSelectionOpenedStateKey.COUPON_WALLET_SIZE_SELECTION,
  );

  const {
    isOpen: isMiniAdpOpen,
    close: closeMiniADP,
    open: openMiniADP,
  } = useMiniAdpDialogOpenedState(
    MiniAdpDialogOpenedStateKey.COUPON_WALLET_MAIN_MINI_ADP,
  );

  return useMemo(() => {
    return {
      open: isMiniADP ? openMiniADP : openSizeSelection,
      isOpen: isMiniADP ? isMiniAdpOpen : isSizeSelectionOpen,
      close: isMiniADP ? closeMiniADP : closeSizeSelection,
    };
  }, [
    openMiniADP,
    openSizeSelection,
    isMiniAdpOpen,
    isSizeSelectionOpen,
    closeMiniADP,
    closeSizeSelection,
  ]);
};
